var SCM = SCM || {};

SCM.SplitScreenHelper = (function (ns, elementManager, stickyToolbarHelper) {

    return {
        isArticlePage: isArticlePage,
        positionSplitScreenBasedOnStandardView: positionSplitScreenBasedOnStandardView,
        positionStandardViewBasedOnSplitScreen: positionStandardViewBasedOnSplitScreen,
        removeDuplicateItemsBasedOnId: removeDuplicateItemsBasedOnId,
        getRightRailWithoutSpecifiedWidgets: getRightRailWithoutSpecifiedWidgets,
        scrollToNoteInSplitView: scrollToNoteInSplitView,
        scrollToRefInSplitView: scrollToRefInSplitView,
        registerXrefClicks : registerXrefClicks,
        findXref : findXref,
        updatePageNumberCss : updatePageNumberCss,
        adjustToolbarMargins : adjustToolbarMargins,
        registerMetricsClicks: registerMetricsClicks        
    };

    function isArticlePage() {
        return $('.widget-ArticleFulltext').length > 0;
    } 

    function isTableElement(elem) {
        return elementManager.elementContainsClass(elem, 'table-wrap');
    }

    function isFigureElement(elem) {
        return elementManager.elementContainsClass(elem, 'js-splitscreen-figure-title') ||
                elementManager.elementContainsClass(elem, 'fig-section');
    }

    function isAudioElement(elem) {
        return elementManager.elementContainsClass(elem, 'js-splitscreen-audio-title') ||
                elementManager.elementContainsClass(elem, 'audio');
    }

    function isVideoElement(elem) {
        return elementManager.elementContainsClass(elem, 'js-splitscreen-video-title') ||
                elementManager.elementContainsClass(elem, 'video');
    }

    function elementIsParentOfClass(elem, className) {
        return elementManager.elementContainsClass(elem.firstElementChild, className);
    }

    function adjustToolbarMargins() {
        // if there are a lot of buttons on the toolbar, make the margins smaller
        // so they don't wrap on full width 
        $('.js-sv-header .toolbar-item').css('margin-right', '1.25em');
    }

    // Position split-view based on standard-view position

    function positionArticleSplitScreenBasedOnStandardView(elem, $scrollablePanel) {
        var elemId = null;
        if (elem !== undefined) {
            elemId = elem.id;
        }
        if (elemId === '') {
            elemId = $(elem).next('span').attr('id');
        } 

        // References
        if (elementManager.elementContainsClass(elem, 'js-splitscreen-backreferences-title') ||
            elementManager.elementContainsClass(elem, 'js-splitview-ref-list')) {
            $scrollablePanel.scrollTop(0);
            $('.js-References-tab-trigger').click();
        }
        // Notes
        else if (elementManager.elementContainsClass(elem, 'js-splitscreen-backnotes-title') ||
                 elementManager.elementContainsClass(elem, 'js-splitscreen-footnotegroup-title') ||
                 elementManager.elementContainsClass(elem, 'js-splitscreen-backfootnotegroup-title') ||
                 elementManager.elementContainsClass(elem, 'footnote')) {
            $scrollablePanel.scrollTop(0);
            $('.js-Notes-tab-trigger').click();
        }
        // Figures & Tables (including audio and video)
        else if (isTableElement(elem) ||
                 isFigureElement(elem) ||
                 isAudioElement(elem) ||
                 isVideoElement(elem)) {
            $scrollablePanel.scrollTop(0);
            $('.js-FiguresTables-tab-trigger').click();
        }
        else {
            // Offset needs to be relative to the parent (scrollable panel),
            // so we don't need to worry about the sticky toolbar
            var offset = document.getElementById(elemId + '-sv').offsetTop;
            $scrollablePanel.scrollTop(offset);
        }
    }

    function positionChapterSplitScreenBasedOnStandardView(elem, $scrollablePanel) {
        // The 'elementIsParentOfClass' check is needed for elements that can have a separate title element.
        // If the top of the screen is between the title and its corresponding element, than the 'current element' might
        // be evaluated to be the 'js-content-section' element, which is a wrapper for what we are actually interested in.

        // References
        if (elementManager.elementContainsClass(elem, 'section-type--references') ||
            elementManager.elementContainsClass(elem, 'js-splitview-ref-list') ||
            elementIsParentOfClass(elem, 'js-splitview-ref-list')) {
            $scrollablePanel.scrollTop(0);
            $('.js-References-tab-trigger').click();
        }
        // Notes
        else if (elementManager.elementContainsClass(elem, 'js-footnotes-target') ||
                 elementManager.elementContainsClass(elem, 'js-end-notes-target') ||
                 elementManager.elementContainsClass(elem, 'js-splitscreen-backnotes-title') ||
                 elementManager.elementContainsClass(elem, 'js-splitscreen-footnotegroup-title')) {
            $scrollablePanel.scrollTop(0);
            $('.js-Notes-tab-trigger').click();
        }
        // Figures & Tables (including audio and video)
        else if (isTableElement(elem) ||
                 elementIsParentOfClass(elem, 'fig-section') ||
                 isFigureElement(elem) ||
                 elementIsParentOfClass(elem, 'audio') ||
                 isAudioElement(elem) ||
                 elementIsParentOfClass(elem, 'video') ||
                 isVideoElement(elem)) {
            $scrollablePanel.scrollTop(0);
            $('.js-FiguresTables-tab-trigger').click();
        }
        // Abstract
        else if (elementManager.elementContainsClass(elem, 'widget-ChapterAbstract')) {
            var splitViewAbstract = elementManager.getElementsByClass($scrollablePanel[0], 'widget-ChapterAbstract');
            $scrollablePanel.scrollTop(splitViewAbstract[0].offsetTop);
        }
        // Section header (h2 tags)
        else if (elementManager.elementContainsClass(elem, 'content-section-header')) {
            var sectionHeaders = elementManager.getElementsByClass($scrollablePanel[0], 'content-section-header');
            for (var i = 0; i < sectionHeaders.length; i++) {
                if (sectionHeaders[i].dataset.magellanDestination === elem.dataset.magellanDestination) {
                    // Offset needs to be relative to the parent (scrollable panel),
                    // so we don't need to worry about the sticky toolbar
                    $scrollablePanel.scrollTop(sectionHeaders[i].offsetTop);
                    return;
                }
            }
        }
        // Unique html structure for 'paywall' elements (added in SCMP-34464)
        else if (elementManager.elementContainsClass(elem, 'js-paywall')) {
            var targetId = elem.querySelector('.js-jumpLoc').id + '-sv';
            var $splitscreenTarget = $scrollablePanel.find('#' + targetId);
            $scrollablePanel.scrollTop($splitscreenTarget[0].offsetTop);
        }
        else {
            var sections = elementManager.getElementsByClassList($scrollablePanel[0], ['js-content-section',
                                                                                       'js-splitscreen-section-title']);
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dataset.statsid === elem.dataset.statsid) {
                    // Offset needs to be relative to the parent (scrollable panel),
                    // so we don't need to worry about the sticky toolbar
                    $scrollablePanel.scrollTop(sections[i].offsetTop);
                    return;
                }
            }
        }
    }

    function positionSplitScreenBasedOnStandardView(elem) {
        var $scrollablePanel = $('#split-view-scroll-pane');

        if (!elem) {
            $scrollablePanel.scrollTop(0);
        }
        else if (isArticlePage()) {
            positionArticleSplitScreenBasedOnStandardView(elem, $scrollablePanel);
        }
        else {
            positionChapterSplitScreenBasedOnStandardView(elem, $scrollablePanel);
        }
    }

     // Position standard-view based on split-view position

    function positionArticleStandardViewBasedOnSplitScreen(elem) {
        var elemId = '';
        if (elem !== undefined) {
            elemId = elem.id;
        }
        if (elemId === '') {
            elemId = $(elem).next('span').attr('id');
        } 

        var heightOffset = stickyToolbarHelper.getStickyToolbarHeight();

        if (elemId) {
            $(window).scrollTop($('#' + elemId.slice(0, -3)).offset().top - heightOffset);
        }
        else {
            $(window).scrollTop(0);
        }
    }

    function positionChapterStandardViewBasedOnSplitScreen(elem) {
        var $standardViewContent = $('.js-content-body');
        var stickyToolbarOffset = stickyToolbarHelper.getStickyToolbarHeight();

        // Abstract
        if (elementManager.elementContainsClass(elem, 'widget-ChapterAbstract')) {
            var standardViewAbstract = elementManager.getElementsByClass($standardViewContent[0], 'widget-ChapterAbstract');
            $(window).scrollTop(standardViewAbstract[0].offsetTop);
        // Header
        } else if (elementManager.elementContainsClass(elem, 'content-section-header')) {
            $(window).scrollTop($('#' + elem.dataset.magellanDestination).offset().top - stickyToolbarOffset);
        // Unique html structure for 'paywall' elements (added in SCMP-34464)
        } else if (elementManager.elementContainsClass(elem, 'js-paywall')) {
            var targetId = elem.querySelector('.js-jumpLoc').id.replace('-sv','');
            $(window).scrollTop($('#' + targetId).offset().top - stickyToolbarOffset);
        // 'Normal' section
        } else if (elementManager.elementContainsClass(elem, 'content-section-header') || elem && elem.dataset.statsid) {
            $(window).scrollTop($('#' + elem.dataset.statsid).offset().top - stickyToolbarOffset);
        // Default: scroll user to top of the page
        } else {
            $(window).scrollTop(0);
        }
    }

    function positionStandardViewBasedOnSplitScreen(elem) {
        if (!elem) {
            $(window).scrollTop(0);
        }
        else if (isArticlePage()) {
            positionArticleStandardViewBasedOnSplitScreen(elem);
        }
        else {
            positionChapterStandardViewBasedOnSplitScreen(elem);
        }
    }

    function removeDuplicateItemsBasedOnId(elArray) {
        var duplicateItems = [];
        for (var i = 0; i < elArray.length; i++) {
            var id = elArray[i].firstChild.id;
            if (duplicateItems.indexOf(id) < 0) {
                duplicateItems.push(id);
            } else {
                elArray.splice(i, 1);
                i--;
            }
        }
    }

    // Related tab (right rail in standard-view)
    function getRightRailWithoutSpecifiedWidgets(widgetExclusionList) {
        // Get right rail and remove widgets in the exclusion list
        var $rightRail = $('.page-column--right').clone();
        elementManager.removeElementsByClassList($rightRail[0], widgetExclusionList);

        // Remove right rail unique id
        $rightRail.removeAttr('id');

        // Remove right rail classes
        $rightRail.removeClass('page-column page-column--right');

        return $rightRail[0];
    }

    function scrollToNoteInSplitView(noteCue, scrollablePanel) {
        if (noteCue === null || noteCue === undefined) {
            return;
        }
        var $paragraph = null;
        var legacySectionId;
        if ($(noteCue).hasClass('js-xref-fn')) {
             legacySectionId = $(noteCue).attr('reveal-id');
        } else {
            legacySectionId = $(noteCue).attr('legacysectionid');
        }
       
        var $footnote = $('.split-view-notes [content-id = "' + legacySectionId + '"]');
        if ($footnote.length) {
            $paragraph = $footnote.find('.fn');
        } else {
            return;
        }
        var notes = elementManager.getElementsByClassList(scrollablePanel, [
            'js-footnotes-target',
            'js-end-notes-target', 
            'footnote']);
       
        for (var i = 0; i < notes.length; i++) {
            var $noteLink = $(notes[i]).find($paragraph);
            if ($noteLink.length) {
                scrollablePanel.switchTo();
                scrollablePanel.scrollTop = 0;
                scrollablePanel.scrollTop = $noteLink.offset().top - 50;
                return;
            }
        }
    }

    function scrollToRefInSplitView(id, scrollablePanel) {
        var references = elementManager.getElementsByClass(scrollablePanel, 'js-splitview-ref-item');
        for (var i = 0; i < references.length; i++) {
            if (references[i].attributes['content-id'].textContent.toLowerCase() === id.toLowerCase()) {
                scrollablePanel.switchTo();
                scrollablePanel.scrollTop = references[i].offsetTop;
                return;
            }
        }
    }

    function registerMetricsClicks() {
        $('.location-right-pane').off('click', '.js-contentmet-modal-trigger, .js-contentmet-views, .js-contentmet-citations');
        $('.location-right-pane').on('click', '.js-contentmet-modal-trigger, .js-contentmet-views, .js-contentmet-citations', function(e) {
            if ($('.js-sv-main:visible').length) {
                e.stopPropagation();
                openMetricsModal('.js-contentmet-modal-trigger', false);
            }
        });
        $('.location-right-pane').off('click', '.js-artmet-modal-trigger, .artmet-condensed-stats .artmet-views');
        $('.location-right-pane').on('click', '.js-artmet-modal-trigger, .artmet-condensed-stats .artmet-views', function(e) {
            if ($('.js-sv-main:visible').length) {
                e.stopPropagation();
                openMetricsModal('.js-artmet-modal-trigger', true);
            }
        });
        $('.location-right-pane').off('click', '.js-contentmet-close-modal, .js-artmet-close-modal');
        $('.location-right-pane').on('click', '.js-contentmet-close-modal, .js-artmet-close-modal', function(e) {
            var articleMetrics = $(e.target) === $('.js-artmet-close-modal');
            closeMetricsModal(articleMetrics);
        });
        $('.location-right-pane .js-contentmet-modal').off('click');
        $('.location-right-pane .js-contentmet-modal').on('click', function(e) {
            if (!$(e.target).closest('.location-right-pane .artmet-modal-contents').length) {
                closeMetricsModal(false);
            }
        });  
        SCM.ContentMetric.reloadOrHideBadges();
    }

    function closeMetricsModal(articleMetrics) {
        if (articleMetrics) {
            ArtMetric.closeModal();            
        } else {
            SCM.ContentMetric.closeModal($('.location-right-pane .artmet-modal-contents'));                        
        }
    }

    function openMetricsModal(triggerClass, articleMetrics) {
        var $modalTrigger = $('.location-right-pane ' + triggerClass);
        var $modal = $('.location-right-pane .artmet-modal-contents');
        // The modal uses the article metrics modal class for both 
        // ArticleLevelMetrics and ContentLevelMetrics, but the
        // open behavior differs between the 2.
        if (articleMetrics) {
            var resourceId = $modalTrigger.attr('data-article-id') ?? $modalTrigger.attr('data-resource-id');
            ArtMetric.triggerModal($modal, resourceId);
        } else {
            var resourceId = $modalTrigger.attr('data-resource-id');
            var resourceType = $modalTrigger.attr('data-resource-type');
            SCM.ContentMetric.triggerModal($modal, resourceId, resourceType);
        }
    }
    
    function registerXrefClicks() {
        $('.location-right-pane').on('click', '.js-xref-sec', function(e) {
            e.stopPropagation();
            var contentFullText = $('.location-left-panel');
            if (contentFullText.length) {
                findXref(this, contentFullText[0]);
            }
        });
    }

    function findXref(el, contentFullText) {
        var contentPane = $('.content-panel');
        if (!contentPane.length) {
            return;
        }
        var id = el.attributes['href'].textContent.substring(1);
        var formulas = contentFullText.querySelectorAll('.disp-formula, .statement');
        for (var i = 0; i < formulas.length; i++) {
            if (formulas[i].attributes['content-id'].textContent === id) {
                var textContent = formulas[i].attributes.class.textContent;
                if (textContent === 'disp-formula') {
                    contentPane[0].scrollTop = formulas[i].parentNode.offsetTop;
                    return;
                } else if (textContent === 'statement') {
                    contentPane[0].scrollTop = formulas[i].offsetTop;
                    return;
                }
            }
        }
        var sections = contentFullText.querySelectorAll('.section-title[data-legacy-id]');
        for (var i = 0; i < sections.length; i++) {
            if (sections[i].attributes['data-legacy-id'].textContent === id) {
                contentPane[0].scrollTop = sections[i].offsetTop;
                return;
            }
        }
        var sectionHeadings = contentFullText.querySelectorAll('[data-id=' + id + ']');
        if (sectionHeadings.length) {
            contentPane[0].scrollTop = sectionHeadings[0].offsetTop;
            return;
        }
    }

    function updatePageNumberCss() {
        // only happens on right pane elements, namely references/notes
        // normally would do this with css, but it doesn't play well with SV
        // when the page break icon displays.  Since we can't do look-ahead css yet
        // doing this in JS.  Right now, page numbers only display in VSI content,
        // since it's only in references/notes section in the right pane where the
        // page break occurs WITHIN the reference citation, it's not likely 
        // to be a big performance impact
        var $pageIcons = $('.dynamic-widget-inner-wrap:visible').find('.js-page-icon');
        // only look for the page break icons
        if ($pageIcons.length) {
            $('.js-sv-references').children().addClass('page-relative'); 
            $('.js-sv-notes').children().addClass('page-relative');
            $pageIcons.each(function() {
                // Move the icon over to adjust for moving page number                
                $(icon).parent().addClass('page-icon-adjust');
            });
        }        
    }
})(SCM.SplitScreenHelper = SCM.SplitScreenHelper || {}, SCM.ElementManager, SCM.StickyToolbarHelper);